var LandrEventType;
(function (LandrEventType) {
    LandrEventType["UserPublicProfileUpdate"] = "UserPublicProfileUpdate";
    LandrEventType["UserWorkAvailabilityUpdate"] = "UserWorkAvailabilityUpdate";
    LandrEventType["LockAutoRefresh"] = "LockAutoRefresh";
    LandrEventType["UnlockAutoRefresh"] = "UnlockAutoRefresh";
    LandrEventType["ReleaseWizardQuit"] = "ReleaseWizardQuit";
    LandrEventType["ReleaseWizardGoToStep"] = "ReleaseWizardGoToStep";
    LandrEventType["ReleaseWizardValidate"] = "ReleaseWizardValidate";
    LandrEventType["ReleaseWizardStepError"] = "ReleaseWizardStepError";
    LandrEventType["ReleaseWizardStepSuccess"] = "ReleaseWizardStepSuccess";
    LandrEventType["ReleaseWizardSubmit"] = "ReleaseWizardSubmit";
    LandrEventType["ReleaseWizardSaveAndQuit"] = "ReleaseWizardSaveAndQuit";
    LandrEventType["ReleaseWizardStartSave"] = "ReleaseWizardStartSave";
    LandrEventType["ReleaseWizardSaveEnd"] = "ReleaseWizardSaveEnd";
    LandrEventType["ReleaseWizardLegacyStateChange"] = "ReleaseWizardLegacyStateChange";
    LandrEventType["ReleaseWizardStartTrackUpload"] = "ReleaseWizardStartTrackUpload";
    LandrEventType["ReleaseWizardEndTrackUpload"] = "ReleaseWizardEndTrackUpload";
    LandrEventType["ReleaseWizardArtistsInUseUpdate"] = "ReleaseWizardArtistsInUseUpdate";
    LandrEventType["ReleaseWizardDisableNextAction"] = "ReleaseWizardDisableNextAction";
    LandrEventType["ReleaseWizardEnableNextAction"] = "ReleaseWizardEnableNextAction";
    LandrEventType["ReleaseWizardArtistsErrors"] = "ReleaseWizardArtistsErrors";
    LandrEventType["SessionsReservationRoomsChange"] = "SessionsReservationRoomsChange";
})(LandrEventType || (LandrEventType = {}));

export { LandrEventType };
